import { FallbackProps } from 'react-error-boundary'

import Emoji from 'common/emoji'

const Error: React.FC<FallbackProps> = () => {
  return (
    <div className="h-full bg-white">
      <img
        style={{ position: 'relative', left: '-102px', top: '-40px' }}
        src="/images/unicorn.svg"
        alt="unicorn"
      />
      <div
        className="mx-auto text-coolGray-800 relative"
        style={{ width: '400px', top: '-60px' }}
      >
        <div className="text-4xl font-bold">
          Something has gone ever so slightly wrong.
        </div>
        <div className="my-6 text-base font-medium">
          Unable to retrieve the selected experiment.
        </div>
        <div className="font-thin">
          Try refreshing the page or select another experiment. If that doesn’t
          work chat with us, we can fix just about anything.{' '}
          <Emoji symbol="👀" verticalShadow="6" />
        </div>
      </div>
    </div>
  )
}

export default Error
